/** Message attached to Apollo/GraphQL errors so Sentry can group them. */
export const GRAPHQL_ERROR_MESSAGE = 'GraphQL Error'

/** Sentry exception `type` for an escaped Apollo error. */
export const APOLLO_ERROR_TYPE = 'ApolloError'

/** DOMException name for a request cancelled via `AbortController.abort()`. */
export const ABORT_ERROR_TYPE = 'AbortError'

/** Sentry `mechanism.type` for an uncaught promise rejection. */
export const UNHANDLED_REJECTION_MECHANISM = 'onunhandledrejection'

/** Benign AbortError messages emitted when in-flight requests are cancelled on navigation/unmount. */
export const ABORT_ERROR_MESSAGE_PATTERN = /AbortError|aborted without reason/
